import { render, staticRenderFns } from "./studyTopicDetails.vue?vue&type=template&id=66f29802&scoped=true"
import script from "./studyTopicDetails.vue?vue&type=script&lang=js"
export * from "./studyTopicDetails.vue?vue&type=script&lang=js"
import style0 from "./studyTopicDetails.vue?vue&type=style&index=0&id=66f29802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f29802",
  null
  
)

export default component.exports